// extracted by mini-css-extract-plugin
export default {"wrapper":"NotificationGroup_wrapper__4tdSL","date":"NotificationGroup_date__kM4C1","divider":"NotificationGroup_divider__x-w0S"};